import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectUpdateCommand, ProjectUpdateResponse } from '../entity/ProjectTypes';

export class UpdateProjectUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectUpdateCommand): Promise<ProjectUpdateResponse> {
    return this.repository.updateProject(command);
  }
}


